/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'twitter': {
    width: 20,
    height: 16,
    viewBox: '0 0 20 16',
    data: '<path pid="0" _fill="#FFF" fill-rule="evenodd" d="M17.965 4.508c0-.175-.004-.35-.012-.522A8.276 8.276 0 0020 1.894a8.295 8.295 0 01-2.356.636A4.065 4.065 0 0019.448.296c-.793.462-1.67.799-2.606.98A4.13 4.13 0 0013.847 0c-2.266 0-4.104 1.809-4.104 4.039 0 .317.036.625.107.92A11.712 11.712 0 011.392.74a3.977 3.977 0 00-.556 2.03 4.02 4.02 0 001.826 3.363 4.122 4.122 0 01-1.858-.505l-.001.051c0 1.957 1.415 3.59 3.292 3.96a4.177 4.177 0 01-1.853.07c.522 1.604 2.037 2.772 3.833 2.805A8.317 8.317 0 01.98 14.242c-.331 0-.658-.019-.979-.056A11.75 11.75 0 006.29 16c7.547 0 11.675-6.155 11.675-11.492z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/twitter.js